import { render, staticRenderFns } from "./Taskdetail.vue?vue&type=template&id=01f46cd2&scoped=true&"
import script from "./Taskdetail.vue?vue&type=script&lang=js&"
export * from "./Taskdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f46cd2",
  null
  
)

export default component.exports